"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AFLIPicture_1 = require("./AFLIPicture");
const FLIPicture_1 = require("./FLIPicture");
const ArtStudioPicture_1 = require("./ArtStudioPicture");
const KoalaPicture_1 = require("./KoalaPicture");
const SpritePad_1 = require("./SpritePad");
const C64Layout_1 = require("./C64Layout");
class C64Writer {
    static toBinary(pixelImage) {
        let result;
        if (pixelImage.mode.id === 'bitmap') {
            if (pixelImage.isHires()) {
                result = new ArtStudioPicture_1.default();
            }
            else {
                result = new KoalaPicture_1.default();
            }
        }
        if (pixelImage.mode.id === 'fli') {
            if (pixelImage.isHires()) {
                result = new AFLIPicture_1.default();
            }
            else {
                result = new FLIPicture_1.default();
            }
        }
        if (pixelImage.mode.id === 'sprites') {
            result = new SpritePad_1.default();
        }
        if (result !== undefined) {
            result.fromPixelImage(pixelImage);
            return result;
        }
        throw new Error(`Output format is not supported for mode ${pixelImage.mode.id}`);
    }
    static toBuffer(image) {
        return Buffer.from(C64Layout_1.default.concat(image.toMemoryMap()));
    }
}
exports.default = C64Writer;
//# sourceMappingURL=C64Writer.js.map